'use-strict';

// eslint-disable-next-line import/no-import-module-exports
import {debounce} from '../components/custom-lodash';

const $ = require('jquery');
const config = require('../config/config');
const shapeSlick = require('./shapeSlick');

/**
 * @function
 * @description Renders the navigation buttons ,depending on the containers,included in the content asset with ID "pdp_footbed_regular_slider_new"
 * @listens renderNavigationButtons
 */
function renderNavigationButtons() {
    $('.footbed-module').each(function () {
        let moduleNavigationButtons = '<nav class="module-navigation">';
        const $footbedWrapper = $(this);
        $footbedWrapper.find('section[class^="section"]').each(function (index) {
            const $currentSection = $(this);
            let sectionNavigationButtons = '';

            $currentSection.find('.slide').each(function (currentSlide) {
                if ($(this).find('figcaption').length > 0) {
                    sectionNavigationButtons += `<button data-slide="${currentSlide}">${$(this)
                        .find('.headline-tertiary')
                        .text()}</button>`;
                }
            });

            $currentSection.find('.section-navigation').append(sectionNavigationButtons);

            const enabledFootbedSectionsArray = $('.footbed-module-asset').data('footbed-sections');
            const sectionselector = $currentSection[0].classList[0];
            if (enabledFootbedSectionsArray.includes(sectionselector)) {
                const $buttonHeading = $currentSection.find('.headline-secondary').text();
                moduleNavigationButtons += `<button class="section-${$buttonHeading.toLowerCase()}" ${
                    index === 0 ? ' class="active"' : ''
                }>${$buttonHeading}</button>`;
            } else {
                $currentSection.remove();
            }
        });

        moduleNavigationButtons += '</nav>';

        $footbedWrapper.find('.headline-primary').after(moduleNavigationButtons);
    });
}

/**
 * @function
 * @description Add animation and positioning of the active wrapper moving on each nav button
 * @listens repositionAnimationOnActiveButton
 */
function repositionAnimationOnActiveButton() {
    const $footbedContainer = $('.footbed-module');
    const $module = $footbedContainer.find('section[class^="section"]');
    const $moduleNavigationButtons = $footbedContainer.find('.module-navigation button');
    const $moduleSections = $module.find('section[class^="section"]');
    const $sectionNavigationButtons = $module.find('.section-navigation button');

    $('<div id="active-nav-section"></div>').appendTo('.module-navigation');
    $moduleNavigationButtons.on('click', function (triggeredEvent, actualEvent) {
        const $currentNavButton = $(this);
        const index = $currentNavButton.index();
        const $mainNavigation = $('.module-navigation');
        const navigationMargin = 24;

        $module.find('.active').removeClass('active');
        $currentNavButton.addClass('active');
        $($moduleSections[index]).addClass('active');

        if (actualEvent !== 'resize') {
            if ($footbedContainer.find('.section-content.slick-initialized').length > 0) {
                $footbedContainer.find('.section-content.slick-initialized').slick('unslick');
            }
            if (!$('.section-shape').find('.default-section').hasClass('inactive')) {
                $('.section-shape').find('.default-section').addClass('inactive');
            }
        } else {
            $module.find('.default-section').removeClass('inactive').addClass('active');
        }

        if ($(window).width() < $mainNavigation.outerWidth() + navigationMargin) {
            if ($currentNavButton.next().offset().left + $currentNavButton.next().outerWidth() > $(window).width()) {
                $mainNavigation.addClass('positioning-in-progress');
                $mainNavigation.addClass('mobile');
            } else {
                $mainNavigation.fadeOut(50);
                $mainNavigation.removeClass('positioning-in-progress');
                $mainNavigation.fadeIn(50);
            }
            $mainNavigation.addClass('mobile');
        } else {
            $mainNavigation.removeClass('mobile');
        }
    });

    $sectionNavigationButtons.first().addClass('active');
    $sectionNavigationButtons.each(function () {
        $(this).on('click', function () {
            $module.find('.active').not('.default-section').removeClass('active');
            $sectionNavigationButtons.removeClass('active');
            $(this).addClass('active');
        });
    });

    const $footbedWrapper = $('.footbed-module');
    $footbedWrapper.find('.module-navigation button:first-of-type').addClass('active');
    $footbedWrapper.find('section[class^="section"]:first-of-type').addClass('active');
    $footbedWrapper.find('.default-section .slide').addClass('active');
    $footbedWrapper.find('.module-navigation button').each(function (index) {
        const $currentNavButton = $(this);
        $currentNavButton.on('click', function () {
            const $activeSection = $currentNavButton.closest('.footbed-module').find('section[class^="section"]');
            sliderActions();

            // section-layers
            $currentNavButton
                .closest('.footbed-module')
                .find('.section-layers')
                .find('.slide')
                .each(function (currentSlide) {
                    const $currentSlideWrapper = $(this);
                    $currentSlideWrapper.css(
                        'z-index',
                        $currentSlideWrapper.closest('.footbed-module').find('.section-layers').find('.slide').length -
                            currentSlide
                    );
                    $currentSlideWrapper.css('transform', `translate(-${currentSlide}00%,0)`);
                });
            $('#active-nav-section').animate({left: ($currentNavButton[0].offsetWidth + 7) * index}, 'slow');

            $currentNavButton.addClass('active');
            $currentNavButton.siblings('.active').removeClass('active');
            $activeSection.removeClass('active');
            $activeSection.eq(index).addClass('active');

            if ($activeSection.is('.section-layers.active')) {
                $currentNavButton
                    .closest('.footbed-module')
                    .find('.section-layers.active')
                    .find('.slide')
                    .each(function () {
                        $(this).css('transform', `translate(0, 0)`);
                    });
            }
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'footbedNavClicked',
                    clickedTab: $(this).closest('.footbed-module').find('section.active[id^="footbed"]')[0].id
                });
            }

            sectionNavigationOnClick();
        });
    });

    $footbedWrapper.find('.slide a').on('click', function () {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'footbedLinkClicked',
                clickedTab: $(this)[0].id
            });
        }
    });
}

/**
 * @function
 * @description Creates empty shadow container
 * @listens addShadowContainer
 */
function addShadowContainer() {
    const $sectionShape = $('.section-shape');
    if ($sectionShape.hasClass('active')) {
        $sectionShape.append('<div class="shadow-container"></div>');
    } else {
        $sectionShape.detach($('.shadow-container'));
    }
}

/**
 * @function
 * @description Set data attribute and trigger on click event on slide
 * @listens sectionNavigationOnClick
 */
function sectionNavigationOnClick() {
    $('[id^="footbed"] button[data-slide]').on('click', function () {
        const $currentButton = $(this);
        const $currentSection = $currentButton.closest('section[class^="section"]');
        const currentContainer = $currentButton
            .closest('section[class^="section"]')
            .find('.section-content')
            .not('.default-section');
        let slideno = $currentButton.data('slide');

        if (currentContainer.length > 0 && !currentContainer.hasClass('slick-initialized')) {
            $currentButton.addClass('active');
            $currentButton.siblings('.active').removeClass('active');
            $currentButton
                .closest('.section-shape')
                .find('.default-section')
                .removeClass('inactive')
                .addClass('active');
            currentContainer.find('.slide').first().addClass('active');
            initializeSliders(currentContainer, $currentButton);
        } else if ($currentSection.find('.section-content.slick-initialized').length > 0) {
            if ($currentSection.is('#footbed-shape')) {
                slideno -= 1;
            }
            currentContainer.find('.slide').removeClass('active');
            currentContainer.slick('slickGoTo', slideno);
        }
    });

    $('[id^="footbed"].active button[data-slide]').first().trigger('click');
}

/**
 * @function
 * @description initialize Sliders on click event on main navigation button
 * @listens initializeSliders
 * @param {HTMLElement} currentContainer - chosen section
 */
function initializeSliders(currentContainer) {
    ['transitionend', 'animationend'].forEach(function (e) {
        document.querySelector('[class^="section"].active .slide').addEventListener(e, slidersLoad, false);
    });

    /**
     *
     */
    function slidersLoad() {
        if (!currentContainer.hasClass('slick-initialized')) {
            if (currentContainer.closest('[id^="footbed"]')[0].id === 'footbed-shape') {
                shapeSlick.sectionShapeInitializeSlider(currentContainer);
            } else {
                currentContainer.not('.slick-initialized').slick({
                    useTransform: true,
                    rtl: document.documentElement.lang === 'ar',
                    lazyLoad: 'ondemand',
                    slidesToShow: currentContainer.find('.slide').length - 0.01,
                    slidesToScroll: 1,
                    dots: true,
                    dotsClass: 'slick-dots-custom',
                    cssEase: 'ease',
                    speed: 800,
                    centerMode: true,
                    infinite: false,
                    arrows: false,
                    responsive: [
                        {
                            breakpoint: config.BREAKPOINTS.TABLET_MAX,
                            settings: {
                                arrows: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerPadding: '30vw'
                            }
                        },
                        {
                            breakpoint: config.BREAKPOINTS.MOBILE_MAX,
                            settings: {
                                arrows: true,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerPadding: '27.5vw'
                            }
                        }
                    ]
                });
            }
        }
    }
}

/**
 * @function
 * @description hit event in case user action has been made
 * @listens sliderActions
 */
function sliderActions() {
    $('.section-content').on('swipe', function (event, slick, currentSlide, nextSlide, direction) {
        const $currentSlide = $('[id^="footbed"] .slick-current');
        const $activeSlideIndex = $(`[id^="footbed"] button[data-slide="${$currentSlide.data('slick-index') + 1}"]`);

        shapeSlick.sectionShapeRepositioning(event, slick, currentSlide, nextSlide, direction);
        if ($currentSlide.length > 0) {
            $('[id^="footbed"] button').removeClass('active');
            $activeSlideIndex.addClass('active');
        }
    });
    $('.section-content').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $(this).find('.slick-slide')[currentSlide].setAttribute('clicked', `from-${currentSlide}-to-${nextSlide}`);
        shapeSlick.sectionShapeRepositioning(event, slick, currentSlide, nextSlide);
    });
}

module.exports = {
    /**
     * @function
     * @description Invoke animation events and layout changes
     * @listens init
     */
    init() {
        renderNavigationButtons();
        repositionAnimationOnActiveButton();
        addShadowContainer();
        const $window = $(window);
        $window.on(
            'load resize',
            debounce(function (e) {
                const $footbedContainer = $('.footbed-module');
                const $moduleNavigationButtons = $footbedContainer.find('.module-navigation button');
                $moduleNavigationButtons.first(e).trigger('click', ['resize']);
            }, 10)
        );

        $('.slick-dots-custom li').on('click', function () {
            const $footbedContainer = $('.footbed-module');
            const $module = $footbedContainer.find('section[class^="section"]');
            const $sections = $module.find('.section-content').not('.default-section');
            const $sectionSlides = $sections.find('.slide');
            const $currentSlide = $sections.find('.slick-current').find('.slide');
            $sectionSlides.removeClass('active');
            $currentSlide.addClass('active');
        });
    }
};
